import axios from "axios";
import webBackApi from "../../api/webBackApi";

const API_BASE = process.env.REACT_APP_BACKEND_URL;


export const updateCamaraById = async (camaraId, data) => {
  try {
    const response = await axios.put(`${API_BASE}/api/camara/update/${camaraId}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating camara:", error);
    throw error;
  }
}

export const createCamara = async (data) => {
  try {
    const response = await axios.post(`${API_BASE}/api/camara/create`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating camara:", error);
    throw error;
  }
}


export const getCustomerCamaras = async (customerId) => {
  console.log(".api", `${API_BASE}/api/camara/getCustomerCamaras/${customerId}`)
  try {
    const response = await axios.get(`${API_BASE}/api/camara/getCustomerCamaras/${customerId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching customer cameras:", error);
    throw error;
  }
}


export const getCustomerCamarasWithoutStockCam = async (customerId) => {
  
  try {
    const response = await axios.get(`${API_BASE}/api/camara/getCustomerCamarasWithoutStockCam/${customerId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching cameras without stockCam:", error);
    throw error;
  }
}


export const getCustomerCamarasWithoutStockChip = async (customerId) => {
  
  try {
    const response = await axios.get(`${API_BASE}/api/camara/getCustomerCamarasWithoutStockChip/${customerId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching cameras without stockChip :", error);
    throw error;
  }
}

export const markExternalChipICCID = async (camaraId) => {
  try {
    const response = await axios.post(`${API_BASE}/api/camara/markChipAsExternal/${camaraId}`);
    return response.data;
  } catch (error) {
    console.error("Error updating camara:", error);
    throw error;
  }
}

export const getPendingCamaras = async () => {
  try {
    const response = await axios.get(`${API_BASE}/api/camara/getPendingCamaras`);
    return response.data;
  } catch (error) {
    console.error("Error fetching pending projects:", error);
    throw error;
  }
}

export const deleteCamaraById = async (camaraId) => {
  try {
    const response = await axios.delete(`${API_BASE}/api/camara/delete/${camaraId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting camara:", error);
    throw error;
  }
}

export const getAllCamaras = async () => {
  try {
    const response = await axios.get(`${API_BASE}/api/camara/getall`);
    return response.data;
  } catch (error) {
    console.error("Error fetching all camaras:", error);
    throw error;
  }
}

export const getCamarasOff = async () => {
  try {
    const response = await axios.get(`${API_BASE}/api/camara/getCamarasOff`);
    return response.data;
  } catch (error) {
    console.error("Error fetching off camaras:", error);
    throw error;
  }
}

// Va al webback (JWT Bearer vía interceptor). El back viejo (/api/customerDashboard/getall,
// /api/camara/getall, etc.) no conoce billingType/renewalDay, viven solo acá.
export const getCamaraBillingType = async (identifier) => {
  try {
    const response = await webBackApi.get(`/api/camaras/${identifier}/billing-type`);
    return response.data;
  } catch (error) {
    console.error("Error fetching camara billing type:", error);
    throw error;
  }
}

// Va al webback (JWT Bearer vía interceptor). Solo ADMIN. Devuelve únicamente las cámaras "mensual" (MRR):
// [{ identifier, billingType, renewalDay }].
export const getMonthlyBillingTypes = async () => {
  try {
    const response = await webBackApi.get('/api/camaras/billing-types');
    return response.data;
  } catch (error) {
    console.error("Error fetching monthly billing types:", error);
    throw error;
  }
}

// Va al webback (JWT Bearer vía interceptor), no al backend viejo de arriba.
// renewalDay solo aplica (y se valida) cuando billingType es "mensual"; se ignora con "paquete_dias".
export const updateCamaraBillingType = async (identifier, billingType, renewalDay) => {
  try {
    const body = billingType === "mensual" ? { billingType, renewalDay } : { billingType };
    const response = await webBackApi.put(`/api/camaras/${identifier}/billing-type`, body);
    return response.data;
  } catch (error) {
    console.error("Error updating camara billing type:", error);
    throw error;
  }
}

// Va al webback (JWT Bearer vía interceptor). A diferencia de billing-type,
// este endpoint busca por ftp_users.username = feedID, no por identifier.
export const updateCamaraApagada = async (feedID, camaraApagada) => {
  try {
    const response = await webBackApi.put(`/api/camaras/${feedID}/camara-apagada`, { camaraApagada });
    return response.data;
  } catch (error) {
    console.error("Error updating camara apagada:", error);
    throw error;
  }
}

// Va al webback (JWT Bearer vía interceptor), busca por feedID igual que camara-apagada
// (no por identifier: son campos distintos del mismo doc de Firestore).
export const getIngestAlerts = async (feedID) => {
  try {
    const response = await webBackApi.get(`/api/camaras/${feedID}/ingest-alerts`);
    return response.data;
  } catch (error) {
    console.error("Error fetching camara ingest alerts:", error);
    throw error;
  }
}

// Va al webback (JWT Bearer vía interceptor), busca por feedID igual que la anterior.
export const updateIngestAlerts = async (feedID, ingestAlertsEnabled) => {
  try {
    const response = await webBackApi.put(`/api/camaras/${feedID}/ingest-alerts`, { ingestAlertsEnabled });
    return response.data;
  } catch (error) {
    console.error("Error updating camara ingest alerts:", error);
    throw error;
  }
}

// Va al webback (JWT Bearer vía interceptor), busca por feedID igual que camara-apagada.
// Solo válido si el status de la cámara en Firebase ya es "Terminado" (si no, el back devuelve 409).
// La url firmada de S3 en la respuesta vence a la hora; no cachearla más allá de ese tiempo.
export const getCamaraFirstImage = async (feedID) => {
  const response = await webBackApi.get(`/api/camaras/${feedID}/first-image`);
  return response.data;
}

// Va al webback (JWT Bearer vía interceptor), busca por feedID igual que camara-apagada.
// El back solo limpia el chipICCID si su valor actual es exactamente "EXTERNO" (400 si no).
export const clearExternalChipICCID = async (feedID) => {
  const response = await webBackApi.delete(`/api/camaras/${feedID}/chip-iccid`);
  return response.data;
}